import { enGB, es, pt } from 'date-fns/locale';
import { setDefaultOptions } from 'date-fns';
import store from '../redux/store';

// Inicializar con el valor de localStorage si existe
let langKey = typeof window !== 'undefined' && localStorage.getItem('language')
  ? localStorage.getItem('language')
  : 'es';
setDefaultOptions({ locale: langKey });

const localeDictionary = {
  es,
  en: enGB,
  pt,
};

export const setLangKey = (key) => {
  langKey = key;
  setDefaultOptions({ locale: localeDictionary[key] });
};

export const t = (name, defaultEmpty = false) => {
  const texts = store.getState().auth.whitelabel?.texts;
  // Siempre usar langKey que ya fue inicializado desde localStorage
  const language = langKey;
  const values = name?.props?.id ?? defaultEmpty ? '' : name;

  // Primero intentar con el idioma actual
  if (texts && texts[language] && texts[language][name]) {
    return texts[language][name];
  }

  // Si no hay traducciones cargadas aún, devolver el key sin modificar
  // Esto evita mostrar texto en español cuando debería ser otro idioma
  if (!texts || Object.keys(texts).length === 0) {
    return values;
  }

  // Solo como último recurso, intentar español
  if (texts && texts?.es && texts?.es[name]) {
    return texts?.es[name];
  }

  return values;
};
